import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import Selection from 'src/components/Selection/Selection';

interface PropsTypes {
    marketModel: MarketModel
    userId: number
}

export const MarketItem = observer('MarketItem', ({ marketModel, userId }: PropsTypes) => {
    const appState = useAppStateContext();

    return (
        <div key={marketModel.id}>
            {marketModel.selectionsIds.length > 0 ? (
                <div key={marketModel.id}>
                    <ul className='outright__selections-list'>
                        {
                            marketModel.selectionsIds.map(selectionId => {
                                const selectionModel = appState.websocketV2.getSelectionAndLoad(marketModel.id, selectionId);
                                if (selectionModel === null) {
                                    return null;
                                }

                                return (
                                    <li key={selectionId}>
                                        <Selection
                                            className='outright__selection'
                                            userId={userId}
                                            marketId={selectionModel.marketId}
                                            selectionId={selectionModel.id}
                                            allowShowSp={true}
                                            name={selectionModel.name}
                                        />
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            ) : (
                <p>There are no available selections</p>
            )}
        </div>
    );
});
